/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/datatypes';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "team_api": {
        "nested": {
          "RetrieveWageSettingRequest": {
            "fields": {
              "teamMemberId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "RetrieveWageSettingResponse": {
            "fields": {
              "wageSetting": {
                "type": ".squareup.team_api.WageSetting",
                "id": 1,
                "rule": "optional"
              },
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 2,
                "rule": "repeated"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.team_api?.nested?.RetrieveWageSettingRequest && !$root.nested?.squareup?.nested?.team_api?.nested?.RetrieveWageSettingResponse) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Represents a retrieve request for the wage setting of a team member.
 * --
 *
 * SOURCE RetrieveWageSettingRequest @ squareup/team_api/endpoints/retrieve-wage-setting.proto at 23:1
 */
export const RetrieveWageSettingRequest = $root.lookupType('squareup.team_api.RetrieveWageSettingRequest');
fixType(RetrieveWageSettingRequest, {
  teamMemberId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(RetrieveWageSettingRequest);
/**
 * --
 * @desc Represents a response from a retrieve request containing the specified `WageSetting` object or error messages.
 * --
 *
 * SOURCE RetrieveWageSettingResponse @ squareup/team_api/endpoints/retrieve-wage-setting.proto at 34:1
 */
export const RetrieveWageSettingResponse = $root.lookupType('squareup.team_api.RetrieveWageSettingResponse');
fixType(RetrieveWageSettingResponse);
Builder.createAndAttachToType(RetrieveWageSettingResponse);